export enum DanceSchoolTypeEnum {
  DANCESCHOOL = 'DANCESCHOOL',
  DANCEORGANISATION = 'DANCEORGANISATION',
}
